exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-app-loading{background:#fff;display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%}.c-app-loading_spinner{height:100px}", ""]);

// exports
